/**
 * 红点服务标识符
 *
 * @public
 */
const IBadgeService = Symbol('service:badge');

export { IBadgeService };
//# sourceMappingURL=badge-service.interface.js.map
